import script from "./GalleryList.vue?vue&type=script&lang=ts&setup=true"
export * from "./GalleryList.vue?vue&type=script&lang=ts&setup=true"

import "./GalleryList.vue?vue&type=style&index=0&id=194137e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-194137e0"]])

export default __exports__